<div class="row col-12 col-sm-12 my-account-container">
  <div class="col-3 col-sm-3 my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'MyReportFileNavNode'"></app-my-account-left-sidenav>
  </div>

  @if (url) {
  <div class="myAccountMyProfile col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
    <h1 class="myProfileTopHeader m-0 pl-2">
      {{'common.myReport_page_text_download_your_reports_NA'|cxTranslate}}
    </h1>
    <div class="myProfileBody fs-18">
      <p class="mb-0 font-bold">{{'common.myReport_page_text_download_your_reports_NA'|cxTranslate}}</p>
      <p>{{'common.myReport_page_text_paragraph1_NA'|cxTranslate}}</p>
      <p class="mt-4 mb-5">{{'common.myReport_page_text_paragraph2_NA'|cxTranslate}}</p>
      @if (url.reports ) {
      @if ((url.reports.length > 0) ) {
      <div class="mt-5 " [ngClass]="isMobile ? '' : 'width_reducer' ">
        <div class="customer_ID_Li my-2" (click)="selectingAll()">
          <span>
            <input type="checkbox" [(ngModel)]="selectAll">
          </span>
          <div class="ml-2 grey">{{'common.myReport_page_text_SelectAll_NA'|cxTranslate}}</div>
        </div>
        <div class="scroller">
          @for (each of url.reports; track each; let i = $index) {
          <div class="customer_ID_Li">
            <span>
              <input type="checkbox" [(ngModel)]="Pricing[i]">
            </span>
            <div class="ml-2 grey">{{each?.code}}</div>
          </div>
          }
        </div>
      </div>
      <button (click)="downloadFiles()"
        class="btn action-button fs-20 mt-5 download-selected-files">{{'common.myReport_page_text_button_NA'|cxTranslate}}
        <img src="/icons/link-dark-grey.svg" style="width: 20px;" alt="">
      </button>
      } @else {
      <p style="margin-top: 255px;">{{'common.no_report_file_to_download'|cxTranslate}}</p>
      }
      } @else {
      <p style="margin-top: 255px;">{{'common.no_report_file_to_download'|cxTranslate}}</p>
      }
    </div>
  </div>
  }
</div>